<template lang="pug">

  section.answer
    .container
      h1 {{text}}
      button(@click="$emit('close')") Siguiente

</template>

<script>
  export default  {
    name: 'answer',
    props: {
      text: String
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .answer {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .container{
    color: black;
    text-align: center;
  }
  button{
    background: black;
    color: red;
    display: inline-block;
    padding: 1rem 1.4rem 1rem 2rem;
    font-size: 1.6rem;
    text-transform: uppercase;
    letter-spacing: 1rem;
    text-align: center;
    margin: 2rem 0;
    border: 2px solid red;
    cursor: pointer;
  }
</style>
